import React, {Key} from "react";
import {Button, Col, message, Modal, Popconfirm, Row, Space, Table, Tag} from "antd";
import {AuthGroup} from "../../domains/auth-group";
import {DataNode} from "antd/lib/tree";
import AuthGroupEdit from "./auth-group-edit";
import AuthGroupTree from "./auth-group-tree";
import {request} from "../../utils/utils";

interface AuthGroupListState {
    authGroupList: AuthGroup[]
    treeData: DataNode[],
    groupEditVisible: boolean,
    selectedAuthGroup?: AuthGroup
    // edit mask, 用于指示是编辑还是新增下级
    // 1 - 编辑
    // 2 - 新增下级
    editMask: number
}


export default class AuthGroupList extends React.Component<any, AuthGroupListState> {
    constructor(props: Readonly<any> | any) {
        super(props);
        this.state = {
            treeData: [],
            authGroupList: [],
            groupEditVisible: false,
            editMask: 0
        }
        this.getAuthGroups("");
    }

    columns = [
        {
            title: "组Id",
            dataIndex: "id",
            key: "id",
            render: (text: string) => <label>{text}</label>
        },
        {
            title: "名称",
            dataIndex: "name",
            key: "name",
            render: (text: string) => <label>{text}</label>
        },
        {
            title: "授权路径",
            dataIndex: "grantedPathList",
            key: "grantedPathList",
            render: (text: string[]) => {
                return text.map((x) => {
                    return <Tag> {x} </Tag>
                })
            }
        },
        {
            title: "所属组",
            dataIndex: "parentId",
            key: "parentId",
            render: (text: string) => <label>{text}</label>
        },
        {
            title: "下级组个数",
            dataIndex: "children",
            key: "children",
            render: (text: AuthGroup[]) => <label>{text.length}</label>
        },
        {
            title: "操作",
            render: (record: AuthGroup) => {
                return (
                    <Space>
                        <Button type="primary" onClick={
                            () => {
                                if(record.id === "root"){
                                    message.error("不能编辑root组")
                                    return
                                }
                                this.setState({groupEditVisible: true, selectedAuthGroup: record, editMask: 1})
                                this.editFormRef.current?.fillUpForm(record)
                            }
                        }>详情</Button>
                        <Button type={"primary"} onClick={
                            () => {
                                this.setState({
                                    groupEditVisible: true,
                                    selectedAuthGroup: record,
                                    editMask: 2
                                })
                            }
                        }>新增下级组</Button>
                        <Popconfirm
                            title="确认删除该授权组吗，该操作将会导致下级所有组被删除"
                            okText="删除"
                            cancelText="取消"
                            onConfirm={()=> {
                                request({
                                    url: "/gateway/authgroup/delete",
                                    method:"GET",
                                    params:{id: record.id}
                                }).then((res) => {
                                    if (res.data) {
                                        message.info("删除成功")
                                        this.getAuthGroups("root")
                                    } else {
                                        message.error("删除失败")
                                    }
                                }).catch(() => {
                                    message.error("删除失败")
                                })

                                // axios.get("/gateway/authgroup/delete?id="+record.id)
                            }}
                        >
                            <Button type={"primary"} danger>删除</Button>
                        </Popconfirm>
                    </Space>
                )
            }
        }
    ]

    editFormRef = React.createRef<AuthGroupEdit>()

    getAuthGroups = (node: string) => {
        request({
            url: "/gateway/authgroup/getbyparent",
            method:"GET",
            params:{id: node}
        }).then((res) => {
            let treeData: DataNode[] = []
            res.data.forEach((x: AuthGroup) => {
                let data: DataNode = {
                    title: x.name,
                    key: x.id,
                    children: []
                }
                if (x.children != null && x.children.length > 0) {
                    x.children.forEach(it => {
                        data.children!.push({
                            title: it.name,
                            key: it.id,
                            children: []
                        })
                    })
                }
                treeData.push(data)

            })
            this.setState({
                authGroupList: res.data,
                treeData: treeData
            })
        })
    }

    handleGroupEditOk = () => {
        this.editFormRef.current!!.submitForm()
    }

    handleEditSubmitSuccess = () => {
        this.setState({
            selectedAuthGroup: undefined,
            groupEditVisible: false
        })
        this.getAuthGroups("");
    }

    handleTreeNodeSelect = (key: Key[]) => {
        if (key.length <= 0)
            return
        let promises = []
        promises.push(this.getData(key[0].toString()))
        promises.push(this.getNodeData(key[0].toString()))

        Promise.all(promises).then(res => {
            let list: AuthGroup[] = []
            res.forEach((it: any) => {
                list.push(...it.value)
            })
            this.setState({authGroupList: list})
        })
    }

    onLoadData = ({key, children}: any) => {
        return new Promise<void>(resolve => {
            if (!children) {
                resolve();
                return;
            }
            const promise: any[] = []
            children.forEach((x: DataNode) => {
                    promise.push(this.getData(x.key.toString()))
                }
            )
            Promise.all(promise).then(res => {
                res.forEach(item => {
                    this.setState((origin, props) => {
                        return {
                            treeData: this.updateTreeData(origin.treeData, item.id, item.value.map((it: AuthGroup) => {
                                return {
                                    title: it.name,
                                    key: it.id
                                }
                            }))
                        }
                    })
                })
                resolve()
            })
        });

    }

    getNodeData = (id: string) => {
        return new Promise(resolve => {
            request({
                url: "/gateway/authgroup/",
                method:"GET",
                params:{id: id}
            }).then((res) => {
                    resolve({
                        id: id,
                        value: [res.data]
                    })
                }
            )
        })
    }

    getData = (id: string) => {
        return new Promise(resolve => {
            request({
                url: "/gateway/authgroup/getbyparent",
                method:"GET",
                params:{id: id}
            }).then((res) => {
                    resolve({
                        id: id,
                        value: res.data
                    })
                }
            )
        })
    }

    private bfs = (tree: DataNode, id: String): DataNode | undefined => {
        if (tree.key === id) {
            return tree
        } else {
            for (const treeElement of tree.children!) {
                let node = this.bfs(treeElement, id)
                if (node != null)
                    return node
            }
        }
        return undefined
    }

    private updateTreeData = (list: DataNode[], key: React.Key, children: DataNode[]): DataNode[] => {
        return list.map(node => {
            if (node.key === key) {
                return {
                    ...node,
                    children,
                };
            }
            if (node.children) {
                return {
                    ...node,
                    children: this.updateTreeData(node.children, key, children),
                };
            }
            return node;
        });
    }


    render() {
        return (
            <div>
                <Row>
                    <Col span={4}>
                        <AuthGroupTree onTreeNodeSelect={this.handleTreeNodeSelect}/>
                        {/*<Tree onSelect={this.handleTreeNodeSelect} loadData={this.onLoadData}*/}
                        {/*      treeData={this.state.treeData}/>*/}
                    </Col>
                    <Col span={20}>
                        <Table columns={this.columns} dataSource={this.state.authGroupList} childrenColumnName={"a"}/>
                    </Col>
                </Row>
                <Modal title="新增认证组"
                       width={800}
                       visible={this.state.groupEditVisible}
                       onCancel={() => {
                           this.setState({groupEditVisible: false})
                       }}
                       onOk={this.handleGroupEditOk}
                       cancelText='取消'
                       okText='新增'
                >
                    <AuthGroupEdit
                        group={this.state.selectedAuthGroup!}
                        mask={this.state.editMask}
                        ref={this.editFormRef}
                        onSubmitSuccess={this.handleEditSubmitSuccess}
                    />
                </Modal>
            </div>
        )

    }
}
